<!-- TODO: make it more generic -->
<button
  [style]="styles()"
  title="{{ title() }}"
  type="{{ buttonType() }}"
  class="btn {{ cssClass() }}"
  [disabled]="disabled() || loading()"
>
  @if (loading()) {
    <div class="loader" [style.borderColor]="loadingBorderColor()"></div>
  } @else {
    <ng-content />
  }
</button>
